<template>
    <div class="cxdate">
        <div class="datebtn">
            <span class="db" @click="setDate(0)">今天</span>
            <span class="db" @click="setDate(1)">昨天</span>
            <span class="db" @click="setDate(2)">本月</span>
            <span class="db" @click="setDate(3)">上月</span>
        </div>
        <div class="sddate">
            <div class="stadate" @click="toDate(1)">
                <img src="./../../assets/stadate.png" class="rlimg"/>
                <span class="rltext">{{staDate}}</span>
            </div>
            <div class="enddate" @click="toDate(2)">
                <img src="./../../assets/enddate.png" class="rlimg"/>
                <span class="rltext">{{endDate}}</span>
            </div>
        </div>
        <div class="btndiv">
            <van-button type="default" class="cxbtn" @click="chaxun">查询</van-button>
        </div>
        <van-popup v-model="sjShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false">
            <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    :min-date="minDate"
                    @confirm="queding"
                    @cancel="quxiao"
            />
        </van-popup>
    </div>
</template>

<script>
    import {formatDate} from "../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                dateType: 0,
                staDate: '开始时间',
                endDate: '结束时间',

                type: '',
                sjShow: false,
                minDate: new Date("1900-01-01"),
                currentDate: new Date()
            };
        },
        async created() {
        },
        methods: {
            toDate(type) {
                if (type == 1) {
                    this.minDate = new Date("1900-01-01")
                    this.currentDate = new Date()
                }
                if (type == 2) {
                    if (!this.staDate || this.staDate == '开始时间') {
                        this.$notify({type: 'danger', message: '请先选择开始时间'});
                        return;
                    }
                    this.minDate = new Date(this.staDate)
                    this.currentDate = new Date()
                }
                this.type = type
                this.sjShow = true
            },
            queding(val) {
                if (this.type == 1) {
                    let date = formatDate(val, 'yyyy-mm-dd')
                    this.staDate = date
                }
                if (this.type == 2) {
                    let date = formatDate(val, 'yyyy-mm-dd')
                    this.endDate = date
                }
                this.quxiao()
            },
            quxiao() {
                this.sjShow = false
            },
            setDate(dateType) {
                this.dateType = dateType
                this.staDate = '开始时间'
                this.endDate = '结束时间'
                let data = {
                    dateType: this.dateType,
                    staDate: '',
                    endDate: '',
                }
                this.$emit("chaxun", data)
            },
            chaxun() {
                if (this.staDate != '开始时间' && this.endDate != '结束时间') {
                    let data = {
                        dateType: '',
                        staDate: this.staDate,
                        endDate: this.endDate,
                    }
                    this.$emit("chaxun", data)
                } else {
                    let data = {
                        dateType:this.dateType,
                        staDate: '',
                        endDate: '',
                    }
                    this.$emit("chaxun", data)
                }
            },
        },
    };
</script>

<style lang="scss" scoped>

    .cxdate {
        padding: 16px 38px;
        background-color: #FFFFFF;
    }

    .datebtn {
        font-size: 13px;
        height: 32px;
        line-height: 32px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 0 15px;
        border-radius: 15px;
        background-color: #F3F2F7;
    }

    .db {
        padding: 0px 5px;
        margin: 0 10px;
        font-weight: bold;
    }

    .sddate {
        margin: 20px 25px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 32px;
        line-height: 32px;
        font-size: 13px;
    }

    .stadate {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .enddate {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .rlimg {
        width: 30px;
        height: 30px;
        margin-right: 5px;
    }

    .rltext {
    }

    .btndiv {
        margin-top: 8px;
        display: flex;
        justify-content: center;
        padding-bottom: 32px;
    }

    .cxbtn {
        width: 60%;
        height: 38px;
        border-radius: 45px;
        background-color: #171C2F;
        color: #FFFFFF;
    }


</style>